import { Button, ButtonGroup, Flex } from "orcs-design-system";

import InboxEmpty from "./InboxEmpty";
import {
  INBOX_FILTERS,
  otherCategoryCount,
  type InboxCategory,
  type InboxCategoryCount,
} from "./kinds";
import { inboxKind, type InboxItem } from "./registry";

const InboxList = ({
  items,
  selectedKey,
  arrivedKey = null,
  category,
  counts,
  hasMore,
  loadingMore,
  onCategoryChange,
  onSelect,
  onLoadMore,
}: {
  items: InboxItem[];
  selectedKey: string | null;
  /** Key the auto-advance just opened; only that card gets the arrive pulse. */
  arrivedKey?: string | null;
  category: InboxCategory;
  counts: InboxCategoryCount[];
  hasMore: boolean;
  loadingMore: boolean;
  onCategoryChange: (category: InboxCategory) => void;
  onSelect: (key: string) => void;
  onLoadMore: () => void;
}) => {
  const otherCount = otherCategoryCount(counts, category);
  return (
    <Flex flexDirection="column" gap="s" width="100%">
      <ButtonGroup
        name="inbox-type-filter"
        items={INBOX_FILTERS}
        value={category}
        onChange={onCategoryChange}
        aria-label="Show"
      />
      {items.length === 0 ? <InboxEmpty otherCount={otherCount} /> : null}
      <Flex flexDirection="column" gap="xs">
        {items.map((item) => {
          const { Card } = inboxKind(item.kind);
          return (
            <Card
              key={item.key}
              item={item}
              selected={item.key === selectedKey}
              arrived={item.key === arrivedKey}
              onSelect={onSelect}
            />
          );
        })}
      </Flex>
      {hasMore ? (
        <Button
          type="button"
          variant="ghost"
          disabled={loadingMore}
          onClick={onLoadMore}
        >
          Load more
        </Button>
      ) : null}
    </Flex>
  );
};

export default InboxList;
